let currentWorkspaceId: string | null = null

export function setPostHogWorkspaceContext(workspaceId: string | null): void {
  currentWorkspaceId = workspaceId
}

export function getPostHogWorkspaceContext(): string | null {
  return currentWorkspaceId
}
